import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { useConfigurationContext } from "../root/ConfigurationContext";
import { mirrorPlanLimits } from "../plan/enforcement";
import { AiAssistant } from "../ai/AiAssistant";
import { ImpersonationBanner } from "../support/ImpersonationBanner";
import Header from "./Header";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  const { planLimits } = useConfigurationContext();
  mirrorPlanLimits(planLimits);
  return (
    <>
      <ImpersonationBanner />
      <Header />
      <main className="max-w-screen-xl mx-auto pt-4 px-4" id="main-content">
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </main>
      <AiAssistant />
      <Notification />
    </>
  );
};
